var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangHongKong(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2940_50090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 34C30.4183 34 34 30.4183 34 26C34 21.5817 30.4183 18 26 18C21.5817 18 18 21.5817 18 26C18 30.4183 21.5817 34 26 34Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.826 24.0516C26.6442 24.8078 26.3211 24.6636 26.1626 25.3231C25.2288 25.0986 24.6536 24.1595 24.8782 23.2256C25.1026 22.2918 26.0418 21.7166 26.9756 21.9412C26.6585 23.2601 26.9886 23.3753 26.826 24.0516Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4028 24.6128C25.0658 25.0194 24.8288 25.2821 25.407 25.6367C24.9049 26.4555 23.8341 26.7122 23.0153 26.2101C22.1965 25.708 21.9397 24.6371 22.4419 23.8184C23.5983 24.5275 23.8097 24.2491 24.4028 24.6128Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1871 27.0899C24.7787 26.5849 24.9552 26.8915 25.4712 26.4512C26.0947 27.1817 26.008 28.2795 25.2775 28.903C24.5469 29.5266 23.4492 29.4398 22.8257 28.7093C23.8574 27.8286 23.658 27.5415 24.1871 27.0899Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4768 28.061C26.1793 27.3423 26.5255 27.2691 26.2661 26.6424C27.1536 26.2751 28.1708 26.6968 28.5381 27.5843C28.9054 28.4717 28.4837 29.489 27.5962 29.8563C27.0776 28.6029 26.7429 28.7038 26.4768 28.061Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1077 26.1835C27.3323 26.2444 27.3695 25.8925 26.6934 25.9455C26.6183 24.9881 27.3337 24.1509 28.2913 24.0757C29.2488 24.0007 30.086 24.7161 30.161 25.6737C28.8086 25.7797 28.8011 26.1292 28.1077 26.1835Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2940_50090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangHongKong);
export default __webpack_public_path__ + "static/media/lang-HongKong.23e14c83396f40048a427529e7d3bcd2.svg";
export { ForwardRef as ReactComponent };